import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AgencyAdAccountsAndStores from './AgencyAdAccountsAndStores';
import { useUiVersion } from '../../context/UserModulesContext';
import { AccountsV2Page } from './accounts_v2/AccountsV2Page';

export const AgencyAdAccountsAndStoresWrapper = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // Bifurcación de la 2.1 (tanda «Agencia 2.1», contrato §3): Conexiones › Cuentas nueva; sin la
    // 2.1, el camino de siempre. Hasta saber la versión, un spinner (nunca un flash del clásico).
    const { isV2, loaded } = useUiVersion();
    if (!loaded) return <AccountsV2Page pending={true}/>;
    if (isV2) return <AccountsV2Page location={location} navigate={navigate}/>;

    // Create a history-like object for backwards compatibility
    const history = {
        push: navigate,
        replace: (path) => navigate(path, { replace: true }),
        // Add other history methods as needed
    };

    return <AgencyAdAccountsAndStores location={location} history={history} />;
}; 